<mat-icon>comment</mat-icon>
<span>{{count}}</span>